<template>
  <div class="language-switch" :aria-label="$t('language.selector')">
    <button type="button" :class="{ 'is-active': locale === 'sw' }" :aria-label="$t('language.swahili')" :aria-pressed="locale === 'sw'" @click="$setLocale('sw')">
      <img src="@/assets/img/employee/flag-sw.svg" alt="">{{ $t('language.sw') }}
    </button>
    <button type="button" :class="{ 'is-active': locale === 'en' }" :aria-label="$t('language.english')" :aria-pressed="locale === 'en'" @click="$setLocale('en')">
      <img src="@/assets/img/employee/flag-en.svg" alt="">{{ $t('language.en') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitch',
  computed: {
    locale() { return this.$localeState.locale },
  },
}
</script>

<style lang="sass" scoped>
.language-switch
  display: grid
  grid-template-columns: repeat(2, 1fr)
  width: 100px
  height: 34px
  padding: 3px
  border-radius: 8px
  background: #eee8dc
  button
    display: flex
    width: 47px
    height: 28px
    min-width: 0
    align-items: center
    justify-content: center
    gap: 4px
    padding: 0
    border: 0
    border-radius: 6px
    color: #8e806a
    font-family: 'Mazzard Soft H', sans-serif
    font-size: 10px
    font-weight: 500
    line-height: 1
    > img
      display: block
      width: 16px
      height: 16px
      border-radius: 50%
      object-fit: cover
    &.is-active
      background: #fff
      color: #49463d
      box-shadow: 0 1px 3px rgba(73, 70, 61, .16)
</style>
